<template>
  <div class="list-result row">
    <!-- TODO: make thumbnail a component -->
    <!-- NOTE: icons are currently loaded from sprite in _svg-icons.twig - consider moving into js app? -->
    <div class="thumbnail col-xs-2 hidden-xs">
      <img v-if="r._source.thumbSrc" :src="r._source.thumbSrc" :alt="r.title">
      <svg class="svg-icon thumb" v-if="!r._source.thumbSrc && r._source.internal_repo === 'vyg'">
        <use xlink:href="#np-book"></use>
      </svg>
      <svg class="svg-icon thumb" v-if="!r._source.thumbSrc && r._source.internal_repo === 'atm'">
        <use xlink:href="#np-archive"></use>
      </svg>
    </div>
    <div class="col-xs-12 col-sm">
      <div class="row">
        <div class="col-xs-12 col-sm-9">
          <div class="row">
            <a :href="r._source.sourceRepos[0].url" class="result-title"
               @mouseover="hoverSrc = r._source.sourceRepos[0].url"
               @mouseout="hoverSrc = ''"
               target="_blank"
            >
              {{ r._source.title }}
              <svg class="svg-icon">
                <use xlink:href="#i-external"></use>
              </svg>
            </a>
          </div>
          <div class="row">
            <span class="result-creator">{{ $filters.joinArray(r._source.creator) }}</span>
            <span v-if="r._source.creator && r._source.sortDate">&nbsp; &mdash; &nbsp;</span>
            <span v-if="r._source.sortDate" class="result-date">{{ dateFormat(r._source.sortDate) }}</span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-3">
          <div class="row">
            <span v-for="source in r._source.sourceRepos" class="source-link"
                  :class="{'active-source' : hoverSrc === source.url }">
                  <a :href="source.url" target="_blank">{{ source.label }}
                    <svg class="svg-icon">
                      <use xlink:href="#i-external"></use>
                    </svg>
                  </a>
                </span>
          </div>
        </div>
        <!-- metadata (short) -->
        <div v-if="!expanded" class="col-xs-12 col-sm-9">
          <div class="row result-description">
            {{ $filters.truncate(r._source.description) }}
          </div>
          <a href="" class="show-details text-small" @click.prevent="expand(r)">+ Show Details</a>
        </div>
        <!-- metadata (full) -->
        <transition name="slide-down" :duration="{ enter: 1000 }">
          <div v-if="expanded" class="col-xs-12 col-sm-9">
            <div class="row">
              <div v-for="key in Object.keys(metadata).sort()" class="result-metadata col-xs-12">
		<!-- display metadata keys except for title field -->
                <span v-if="key!=='title'" class="metadata-label">{{metadata[key].label}}: </span>
                <span v-if="!metadata[key].isFacet && key!=='title'">{{ $filters.joinArray(metadata[key].value) }}</span>
                <span v-if="metadata[key].isFacet" v-for="(v, index) in makeArray(metadata[key].value)">
                    <span v-if="index != 0">; </span><a href="" type="button" class="filter-term"
                                                        @click.prevent="filterTerm(key, v)"
                                                        title="Click to filter by this term.">{{ $filters.capitalize(v) }}</a>
                  </span>
              </div>
            </div>
            <!--<a href="" class="show-details text-small" @click.prevent="expand">- Hide Details</a>-->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script setup>

  import { useResults } from 'lit-discovery/vue/composables/useResults'
  import { onBeforeMount } from 'vue';

  // need to define props.r here.
  const props = defineProps({
    r: Object
  })

  // use refs and methods from useRusults
  const { 
    hoverSrc, 
    expanded, 
    metadata, 
    expand, 
    filterTerm, 
    makeArray, 
    dateFormat 
  } = useResults();

  // Chung results beforeMount methods
  onBeforeMount(() => {
      const result = props.r;
      result._source.sourceRepos = [];
      if (result._source.doi && result._source.doi !== 'false') {
        result._source.sourceRepos.push({
          label: "Open Collections",
          url: result._source.digitalObjectURL
        });
        if (result._source.internal_iiif_handle) {
          result._source.thumbSrc = "https://iiif.library.ubc.ca/image/" + result._source.internal_iiif_handle + "/full/200,/0/default.jpg?nice"
        } else {
          result._source.thumbSrc = "https://via.placeholder.com/120"
        }
      }
      if (result._source.internal_repo === "atm") {
        result._source.sourceRepos.push({
          label: "RBSC Archives",
          url: result._source.physicalObjectURL
        })
      }
      if (result._source.internal_repo === "vyg") {
        result._source.sourceRepos.push({
          label: "Library Catalogue",
          url: result._source.physicalObjectURL
        })
      }
      if (result._source.sourceRepos.length < 1) {
        console.log('could not assign internal repo!', result);
        result._source.sourceRepos.push({
          label: "unknown source",
          url: result._source.physicalObjectURL || result._source.physicalObjectURL
        })
      }
  })

</script>
